import { apiClient } from "@base/api/client";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { UseSuspenseQueryOptions } from "@tanstack/react-query";

interface AISummaryResponse {
  summary: string;
}

async function fetchAISummary(): Promise<AISummaryResponse> {
  const response = await apiClient.get<AISummaryResponse>("/project-management/api/projects/summary");
  return response.data;
}

export function aiSummaryQueryOptions() {
  return {
    queryKey: ["ai-summary"] as const,
    queryFn: fetchAISummary,
  };
}

export function useAISummaryQuery(options?: Omit<UseSuspenseQueryOptions<AISummaryResponse>, "queryKey" | "queryFn">) {
  return useSuspenseQuery({ ...aiSummaryQueryOptions(), ...options });
}
